/**
 * Tamano de las portadas en las rejillas.
 *
 * El ancho no se aplica a una pantalla suelta sino a toda la app, con una
 * variable CSS en la raiz: la rejilla de Buscar y la de Explorar son la misma
 * que la de Biblioteca, y verlas de tamanos distintos quedaria raro.
 *
 * Los anchos no son redondos porque lo que importa es cuantas columnas salen
 * en un iPhone. Con ~358 px utiles y 12 px de hueco, el numero de columnas es
 * floor((358 + 12) / (ancho + 12)), asi que 86 y 108 dan las mismas tres y no
 * se notaria la diferencia. Estos cuatro dan 4, 3, 2 y 1.
 *
 * Para que solo quepa una hace falta pasar de 173; 240 lo consigue en
 * cualquier telefono y en el PC, donde hay ancho de sobra, sigue llenando la
 * fila con las que quepan.
 *
 * El titulo crece con la portada: 12 px debajo de una portada de media
 * pantalla se leia como un pie de foto perdido.
 */

export type Tamano = 'pequena' | 'mediana' | 'grande' | 'ultragrande'

export interface OpcionTamano {
  id: Tamano
  nombre: string
  ancho: number
  /** Tamano del titulo debajo de la portada, en px */
  letra: number
  nota: string
}

export const TAMANOS: OpcionTamano[] = [
  {
    id: 'pequena',
    nombre: 'Pequenas',
    ancho: 74,
    letra: 12,
    nota: 'Cuatro por fila, se ve mas de golpe',
  },
  { id: 'mediana', nombre: 'Medianas', ancho: 108, letra: 12, nota: 'Tres por fila' },
  {
    id: 'grande',
    nombre: 'Grandes',
    ancho: 160,
    letra: 13,
    nota: 'Dos por fila, portadas mas visibles',
  },
  {
    id: 'ultragrande',
    nombre: 'Ultragrandes',
    ancho: 240,
    letra: 16,
    nota: 'Una por fila en el movil, portada de media pantalla',
  },
]

const CLAVE = 'yomou.tamanoRejilla'
const POR_DEFECTO: Tamano = 'mediana'

export function leerTamano(): Tamano {
  const guardado = localStorage.getItem(CLAVE)
  return TAMANOS.some((t) => t.id === guardado) ? (guardado as Tamano) : POR_DEFECTO
}

export function aplicarTamano(tamano: Tamano) {
  const opcion = TAMANOS.find((t) => t.id === tamano) ?? TAMANOS[1]!
  document.documentElement.style.setProperty('--ancho-portada', `${opcion.ancho}px`)
  document.documentElement.style.setProperty('--letra-titulo', `${opcion.letra}px`)
  localStorage.setItem(CLAVE, opcion.id)
}
